import { EventName } from "../EventName";

export abstract class BaseEvent {
    public abstract get name(): EventName;
}